<template>
    <div class="assign-account-lookup">
        <v-text-field
            v-model="search"
            label="Search name, account ID, phone, or address"
            placeholder="Type at least 2 characters..."
            prepend-icon="mdi-magnify"
            hide-details
            clearable
            @input="onSearch"
        ></v-text-field>

        <div v-if="loading" class="grey--text mt-2">Searching accounts...</div>
        <div
            v-else-if="search && search.length >= 2 && !results.length"
            class="grey--text mt-2"
        >
            No matching accounts
        </div>

        <div v-if="results.length" class="assign-account-results mt-2">
            <div class="caption grey--text mb-1">
                {{ results.length }} result{{ results.length === 1 ? "" : "s" }}
            </div>
            <v-card
                v-for="account in results"
                :key="account.accountID"
                class="assign-account-card pa-2 mb-2"
                :class="{
                    'assign-account-card--selected':
                        selected && selected.accountID === account.accountID,
                }"
                @click.native="select(account)"
            >
                <div class="font-weight-medium">
                    {{ account.name || "—" }}
                    <span
                        v-if="account.hname"
                        class="grey--text font-weight-regular"
                    >
                        · {{ account.hname }}
                    </span>
                </div>
                <div class="caption mt-1">
                    <span class="font-weight-medium">{{ account.accountID }}</span>
                    <span v-if="account.homePhone">
                        · {{ formatPhone(account.homePhone) }}
                    </span>
                    <span v-if="account.cellPhone">
                        · {{ formatPhone(account.cellPhone) }}
                    </span>
                </div>
                <div v-if="account.address1" class="caption grey--text">
                    {{ account.address1 }}
                </div>
            </v-card>
        </div>

        <v-card
            v-if="selected && selected.accountID"
            class="assign-account-selected pa-3 mt-3"
        >
            <div class="caption font-weight-medium success--text mb-1">
                Selected account
            </div>
            <div class="subheading font-weight-medium">
                {{ selected.name || selected.accountID }}
            </div>
            <div v-if="selected.hname">{{ selected.hname }}</div>
            <div class="mt-1">Account ID {{ selected.accountID }}</div>
            <div v-if="selected.address1">{{ selected.address1 }}</div>
            <div v-if="selected.homePhone || selected.cellPhone">
                {{ formatPhone(selected.homePhone) }}
                <span v-if="selected.homePhone && selected.cellPhone"> · </span>
                {{ formatPhone(selected.cellPhone) }}
            </div>
            <div v-if="selected.emailAddress">{{ selected.emailAddress }}</div>
        </v-card>
    </div>
</template>
<script>
import { formatPhoneNumber } from "../../utils/helpers.js";

export default {
    name: "AssignAccountLookup",
    props: {
        value: String,
    },
    data() {
        return {
            search: "",
            loading: false,
            results: [],
            selected: null,
            searchTimer: null,
        };
    },
    methods: {
        onSearch() {
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
            }

            this.searchTimer = setTimeout(() => {
                this.loadResults();
            }, 300);
        },
        async loadResults() {
            const value = (this.search || "").trim();
            if (value.length < 2) {
                this.results = [];
                return;
            }

            this.loading = true;

            try {
                const results = await this.$http.get(
                    "api/accounts/searchAccounts?value=" +
                        encodeURIComponent(value)
                );
                this.results = results || [];
            } catch (e) {
                this.results = [];
            }

            this.loading = false;
        },
        select(account) {
            this.selected = account;
            this.$emit("input", account.accountID);
            this.$emit("selected", account);
        },
        formatPhone(value) {
            return value ? formatPhoneNumber(value) : "";
        },
        clear() {
            this.search = "";
            this.results = [];
            this.selected = null;
            this.$emit("input", "");
            this.$emit("selected", null);
        },
    },
};
</script>
<style>
.assign-account-results {
    max-height: 280px;
    overflow-y: auto;
}

.assign-account-card {
    cursor: pointer;
    border: 1px solid #e0e0e0;
}

.assign-account-card--selected {
    border-color: #4caf50;
    background: #f1ffdc;
}

.assign-account-selected {
    border: 2px solid #4caf50;
    background: #f1ffdc;
}
</style>
